<template>
  <div>
    <v-dialog 
    :value="value" 
    @input="close" 
    transition="fade-transition" 
    max-width="800px">
      <v-card style="height:100%">
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <div class="h3 mt-2">{{ viewSample.title || 'Stats example' }}</div>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-container fluid class="pa-4">
          <div v-if="sampleImages.length">
            <v-carousel
              v-if="sampleImages.length > 1"
              v-model="currentSlide"
              show-arrows
              height="580"
              class="grey lighten-2 payout-sample-carousel"
            >
              <v-carousel-item
                v-for="image in sampleImages"
                :key="image.url"
              >
                <v-img
                  :src="imgBaseURL + image.url"
                  :lazy-src="imgBaseURL + image.url"
                  :alt="image.title"
                  contain
                  height="530"
                  class="white"
                />
              </v-carousel-item>
            </v-carousel>
            <v-img
              v-else
              :src="imgBaseURL + sampleImages[0].url"
              :lazy-src="imgBaseURL + sampleImages[0].url"
              :alt="sampleImages[0].title"
              contain
              max-height="560"
              class="grey lighten-2"
            />
            <div
              v-if="sampleImages.length > 1"
              class="text-center caption font-weight-medium mt-2"
              aria-live="polite"
            >
              Slide {{ currentSlide + 1 }} of {{ sampleImages.length }}
            </div>
          </div>
          <v-card v-else-if="viewSample.metrics" outlined class="pa-5">
            <div class="subtitle-1 font-weight-bold mb-3">Stats to submit</div>
            <v-chip
              v-for="metric in viewSample.metrics"
              :key="metric"
              class="ma-1"
              color="secondary"
              outlined
            >{{ metric }}</v-chip>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'PayoutSampleModal',
  props: ['type', 'value'],
  data () {
    return {
      imgBaseURL: '/static/img/payout_samples/',
      sampleConfig: [
        {
          title: 'IG Reel',
          type: 'igReel',
          images: [
            {
              title: 'IG Reel stats (reach, views, engagements)',
              url: 'IGR_IGP_eg.png'
            }
          ]
        },
        {
          title: 'IG Post',
          type: 'igPost',
          images: [
            {
              title: 'Igp stats (reach, impressions, engagements)',
              url: 'IGR_IGP_eg.png'
            }
          ]
        },
        {
          title: 'IG Story',
          type: 'igStory',
          images: [
            {
              title: 'Igs stats',
              url: 'IGS_eg.png'
            }
          ]
        },
        {
          title: 'TikTok',
          type: 'tiktok',
          images: [
            {
              title: 'Tiktok stats',
              url: 'tt_eg.png'
            }
          ]
        },
        {
          title: 'XHS Post',
          type: 'xhs',
          metrics: ['Views', 'Average Watch Time', 'Likes', 'Saves', 'Comments', 'Shares']
        },
        {
          title: 'Facebook Post',
          type: 'facebook',
          metrics: ['Reach', 'Impressions', 'Reactions', 'Comments', 'Shares', 'Post clicks']
        },
        {
          title: 'LinkedIn Post',
          type: 'linkedin',
          images: [
            {
              title: 'LinkedIn discovery insights',
              url: 'linkedin-discovery.png'
            },
            {
              title: 'LinkedIn video performance and profile activity insights',
              url: 'linkedin-video-performance.png'
            },
            {
              title: 'LinkedIn engagement insights',
              url: 'linkedin-engagement.png'
            }
          ]
        },
        {
          title: 'X (Twitter) Post',
          type: 'twitter',
          metrics: ['Impressions', 'Replies', 'Likes', 'Reposts', 'Bookmarks']
        }
      ],
      viewSample: {},
      currentSlide: 0
    }
  },
  computed: {
    sampleImages() {
      return this.viewSample.images || []
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newType) {
        if (newType) {
          this.viewSample = this.sampleConfig.find(sample => sample.type === newType)
          this.currentSlide = 0
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('input')
    }
  }
}
</script>
<style>
.payout-sample-carousel .v-carousel__controls {
  background-color: #efffd6 !important;
}

.payout-sample-carousel .v-carousel__controls .v-btn {
  color: #3f3fff !important;
  opacity: 0.45 !important;
}

.payout-sample-carousel .v-carousel__controls .v-btn.v-btn--active {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// PayoutSampleModal.vue?496e6074